import React from 'react';
import { WorkOrderDataProvider } from './WorkOrderDataContext';
import { WorkOrderLayoutProvider } from './WorkOrderLayoutContext';
import { WorkOrderSelectionProvider } from './WorkOrderSelectionContext';

const WorkOrdersProvider = ({ children }: { children: React.ReactNode }) => (
  <WorkOrderDataProvider>
    <WorkOrderLayoutProvider>
      <WorkOrderSelectionProvider>{children}</WorkOrderSelectionProvider>
    </WorkOrderLayoutProvider>
  </WorkOrderDataProvider>
);

export { WorkOrdersProvider };
export { useWorkOrderData } from './WorkOrderDataContext';
export { useWorkOrderLayout } from './WorkOrderLayoutContext';
export { useWorkOrderSelection } from './WorkOrderSelectionContext';
